export default {
  preferences: {
    title: "Einstellungen",
    promo: {
      blurb: "Erweiterte Plays.\nTiefere Insights.",
    },
    sections: {
      account: "Konto",
      display: "Anzeige",
      support: "Support",
      about: "Über",
    },
    items: {
      profile: "Profil",
      location: "Standort",
      manageSubscription: "Abo verwalten",
      glossary: "Glossar",
      contactSupport: "Support kontaktieren",
      logOut: "Ausloggen",
      deleteAccount: "Konto löschen",
    },
    profile: {
      title: "Profil",
      alerts: {
        passwordMessage: "Um dein Passwort zu ändern, besuche linemate.io",
        usernameInvalid: "Dein Benutzername muss mindestens 6 Zeichen lang sein. Er darf nur Buchstaben und Zahlen enthalten.",
        usernameTaken: "Dieser Benutzername ist bereits vergeben",
      },
      saved: "Profil gespeichert",
    },
    display: {
      preferences: {
        theme: "Theme",
        odds: "Quoten",
        language: "Sprache",
      },
      options: {
        theme: {
          "Match System": "System übernehmen",
          Light: "Hell",
          Dark: "Dunkel",
        },
        odds: {
          american: "Amerikanisch",
          decimal: "Dezimal",
        },
      },
    },
    language: {
      loading: "Sprache wird aktualisiert...",
    },
    about: {
      terms: "Bedingungen",
      privacy: "Datenschutz",
      responsibleGambling: "Verantwortungsvolles Spielen",
      openSourceLibraries: "Open-Source-Bibliotheken",
      acknowledgments: "Danksagungen",
    },
    subscription: {
      alertTitle: "Abo",
      webMessage: "Um dein Abo zu verwalten, besuche bitte den Profilbereich auf linemate.io",
      googlePlayMessage: "Um dein Abo zu verwalten, besuche bitte den Bereich Abos deines mit diesem Kauf verknüpften Google-Play-Store-Kontos",
      appleMessage: "Um dein Abo zu verwalten, besuche bitte den Bereich Abos deines mit diesem Kauf verknüpften Apple-Kontos",
      manageTitle: "Abo verwalten",
      currentPlan: "Aktueller Plan",
      changePlan: "Plan ändern",
      cancelPlan: "Abo kündigen",
      cancelTitle: "Abo kündigen",
      cancelHeading: "Warum kündigst du?",
      cancelSubtitle: "Dein Feedback hilft uns, unser Produkt zu verbessern.",
      missingTitle: "Was fehlt?",
      missingSubtitle: "Welche Funktionen oder Tools würden Linemate für dich wertvoller machen?",
      improveTitle: "Sag uns, wie wir uns verbessern können",
      improveSubtitle: "Dein Feedback hilft uns, besser zu werden.",
      trialActive: "Deine Linemate+-Testphase ist noch aktiv.",
      alreadyActive: "Du hast bereits Zugriff auf Linemate+",
      exclusiveOfferFallbackTitle: "Exklusives Angebot",
      exclusiveOfferFallbackSubtitle: "Behalte deinen Zugriff mit einem zeitlich begrenzten Angebot, bevor du kündigst.",
      claimOneTimeOffer: "Einmaliges Angebot einlösen",
      offerApplyFailure: "Wir konnten dieses Angebot gerade nicht anwenden. Bitte versuche es später erneut.",
      continueToCancel: "Mit Kündigung fortfahren",
      losingAccessTitle: "Du verlierst den Zugriff auf unsere neuesten erweiterten Funktionen",
      losingAccessSubtitle: "Das verlierst du, wenn dein Plan endet.",
      keepSubscription: "Abo behalten",
      feedbackPlaceholder: "Antwort eingeben...",
    },
    providers: {
      locationTitle: "Erlaube Linemate den Zugriff auf deinen Standort, um deine bevorzugten Quoten festzulegen",
      locationSubtitle: "Linemate nutzt deinen Standort, um Anbieter in deiner Region anzuzeigen",
    },
    location: {
      title: "Standort",
      useCurrentLocation: "Aktuellen Standort verwenden",
      enableLocationMessage: "Spare Zeit und erlaube die Standortfreigabe, damit wir dir die besten Märkte und Angebote anzeigen können.",
    },
    logout: {
      title: "Ausloggen",
      message: "Möchtest du dich wirklich ausloggen?",
    },
    deleteAccount: {
      warningTitle: "Warnung",
      warningMessage: "Du hast derzeit ein aktives Abo. Du musst es kündigen, bevor du dein Konto löschen kannst.",
      confirmTitle: "Konto löschen",
      confirmMessage: "Möchtest du dein Konto wirklich löschen?",
      confirmAction: "Löschen",
      successTitle: "Konto löschen",
      successMessage: "Dein Konto wurde erfolgreich gelöscht.",
      errorTitle: "Fehler",
    },
    communication: {
      title: "Kommunikation",
      email: "E-Mail",
      emailDescription: "Marketing-E-Mails, Forschungsupdates, Produktneuigkeiten und gelegentliche Plattformankündigungen.",
      notificationSettings: "Benachrichtigungseinstellungen",
      notificationDescription: "Marketingbenachrichtigungen, Erinnerungen vor wichtigen Spielphasen und Updates zu neuen Funktionen.",
    },
    feedback: {
      title: "Feedback teilen",
      enjoymentPrompt: "Gefällt dir deine Erfahrung?",
      improvePrompt: "Sag uns, wie wir uns verbessern können. Jedes Feedback hilft.",
      actions: {
        yes: "Ja",
        no: "Nein",
        contactUs: "Kontaktiere uns",
        notNow: "Nicht jetzt",
      },
      communication: {
        title: "Kommunikation",
        email: "E-Mail",
        emailDescription: "Marketing-E-Mails, Forschungsupdates, Produktneuigkeiten und gelegentliche Plattformankündigungen.",
        notificationSettings: "Benachrichtigungseinstellungen",
        notificationDescription: "Marketing-Benachrichtigungen, Erinnerungen vor wichtigen Spielzeiten und Updates zu neuen Funktionen.",
      },
    },
  },
};
